export enum SearchFieldIdentifiers {
  CASUAL = 'cu',
  CONTEXT = 'co',
  POWER = 'pu',
  ELEMENT = 'el',
  ENTITY = 'en',
  SEARCH_TERM = 'st',
  SEARCH_FIELD = 'sfi',
  FACT = 'fa'
}

export enum SearchType {
  CASUAL,
  CONTEXT,
  POWER
}

export const SearchFieldQueryParam = 'searchfield';

export enum SearchFieldAction {
  REMOVED = 'removed',
  ADDED = 'added',
  UPDATED = 'updated'
}
